import typeforce from '@exodus/typeforce';
import assert from 'minimalistic-assert';
const nonEmptyString = (value) => typeof value === 'string' && value.length > 0;
const nonEmptyStringArray = (value) => {
    return Array.isArray(value) && value.length > 0 && value.every(nonEmptyString);
};
const parseStorageOpts = (opts) => {
    typeforce({
        namespace: typeforce.oneOf(nonEmptyString, nonEmptyStringArray),
        interfaceId: typeforce.maybe(nonEmptyString),
    }, opts);
    return {
        interfaceId: opts.interfaceId || 'storage',
        namespace: Array.isArray(opts.namespace) ? opts.namespace : [opts.namespace],
    };
};
const hasStorage = (node) => 'storage' in node;
const namespaceStorage = () => {
    const preprocess = (node) => {
        if (!hasStorage(node) || !node.storage)
            return node;
        const { definition, storage, ...rest } = node;
        const { namespace: namespaceArr, interfaceId: storageInterfaceId } = parseStorageOpts(storage);
        return {
            ...rest,
            definition: {
                ...definition,
                factory: (deps) => {
                    const namespacedDeps = { ...deps };
                    const baseStorage = namespacedDeps[storageInterfaceId];
                    assert(baseStorage, `expected param "${storageInterfaceId}"`);
                    namespacedDeps[storageInterfaceId] = namespaceArr.reduce((currentStorage, part) => {
                        return currentStorage.namespace(part);
                    }, baseStorage);
                    return definition.factory(namespacedDeps);
                },
            },
        };
    };
    return { type: 'node', preprocess };
};
export default namespaceStorage;
